export const LABELS = {
    developmentPeriod: 'Development',
    startDate: 'Pro forma start',
    operationStartDate: 'Operation start',
    saleMonth: 'Sale month',
    firstStabilizedMonth: '1st stabilized month',
};
